﻿
/**
    * helpers for filtering and ranking arrays for autocomplete type functionality
    */
export class SearchUtils
{

    public static search<T>(query: string, arr: T[], valueFn: (item: T) => string, maxItems: number = 10, matchFn: (item: T) => void = null, noMatchFn: (item: T) => void = null): T[] {
        var sorted: T[] = [];

        var add = (item) => {// Insert using binary search.      
            var value = valueFn(item);          
            var score = scoreDb[value];
            var indexMin = 0;
            var indexMax = sorted.length;
            while (indexMin < indexMax) {
                var indexMid = Math.floor((indexMin + indexMax) / 2);
                var midScore = scoreDb[valueFn(sorted[indexMid])];

                //if the insert item is less than existing
                if (score > midScore) {
                    indexMax = indexMid;
                } else if (score < midScore) {
                    indexMin = indexMid + 1;
                } else { //they are equal
                    indexMin = indexMid;
                    break;
                }
            }
            sorted.splice(indexMin, 0, item);
        };

        //first get rid of duplicates
        var db = {};
        arr.forEach(item => db[valueFn(item)] = item);
        var scoreDb: { [value: string]: number } = {};

        var keys = Object.keys(db);
        for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            var score = 0;
            if (key && query) score = SearchUtils.score(key, query, 0);
            if (score > 0) {
                scoreDb[key] = score;
                add(db[key]);
                if (matchFn) matchFn(db[key]);
            } else {
                if (noMatchFn) noMatchFn(db[key]);
            }
        }
            
        if (maxItems > 0 && sorted.length >= maxItems) {
            sorted = sorted.slice(0, maxItems - 1);
        }

        return sorted;
    }
        
    /*!
        * string_score.js: String Scoring Algorithm 0.1.22
        *
        * http://joshaven.com/string_score
        * https://github.com/joshaven/string_score
        */
    public static score(phrase: string, query: string, fuzziness: number): number {
        // If the string is equal to the word, perfect match.
        if (phrase === query) { return 1; }

        //if it's not a perfect match and is empty return 0
        if (query === "") { return 0; }

        var runningScore = 0,
            charScore,
            finalScore,
            string = phrase,
            lString = string.toLowerCase(),
            strLength = string.length,
            lWord = query.toLowerCase(),
            wordLength = query.length,
            idxOf,
            startAt = 0,
            fuzzies = 1,
            fuzzyFactor,
            i;

        // Cache fuzzyFactor for speed increase
        if (fuzziness) { fuzzyFactor = 1 - fuzziness; }

        // Walk through word and add up scores.
        // Code duplication occurs to prevent checking fuzziness inside for loop
        if (fuzziness) {
            for (i = 0; i < wordLength; i += 1) {

                // Find next first case-insensitive match of a character.
                idxOf = lString.indexOf(lWord[i], startAt);

                if (idxOf === -1) {
                    fuzzies += fuzzyFactor;
                } else {
                    if (startAt === idxOf) {
                        // Consecutive letter & start-of-string Bonus
                        charScore = 0.7;
                    } else {
                        charScore = 0.1;

                        // Acronym Bonus
                        // Weighing Logic: Typing the first character of an acronym is as if you
                        // preceded it with two perfect character matches.
                        if (string[idxOf - 1] === ' ') { charScore += 0.5; }
                    }

                    // Same case bonus.
                    if (string[idxOf] === query[i]) { charScore += 0.1; }

                    // Update scores and startAt position for next round of indexOf
                    runningScore += charScore;
                    startAt = idxOf + 1;
                }
            }
        } else {
            for (i = 0; i < wordLength; i += 1) {
                idxOf = lString.indexOf(lWord[i], startAt);
                if (-1 === idxOf) { return 0; }

                if (startAt === idxOf) {
                    charScore = 0.7;
                } else {
                    charScore = 0.1;
                    if (string[idxOf - 1] === ' ') { charScore += 0.5; }
                }
                if (string[idxOf] === query[i]) { charScore += 0.1; }
                runningScore += charScore;
                startAt = idxOf + 1;
            }
        }

        // Reduce penalty for longer strings.
        finalScore = 0.5 * (runningScore / strLength + runningScore / wordLength) / fuzzies;

        if ((lWord[0] === lString[0]) && (finalScore < 0.85)) {
            finalScore += 0.15;
        }

        return finalScore;
    }
        




}